// Reusable polling function: checks every 100ms for max checks (default 100 = 10 seconds)
function pollWithTimeout(checkFn, maxChecks) {
  maxChecks = maxChecks || 100; // Default to 100 checks (10 seconds)
  var checkCount = 0;

  // Run immediately first to avoid initial delay
  try {
    var result = checkFn(checkCount);
    if (result === true) {
      return null; // Success, no need to set up interval
    }
    checkCount++;
  } catch (err) {
    // Silent error handling
    checkCount++;
  }

  // If not found immediately, set up interval for polling
  var interval = setInterval(function () {
    if (checkCount >= maxChecks) {
      clearInterval(interval);
      return;
    }

    try {
      var result = checkFn(checkCount);
      if (result === true) {
        clearInterval(interval);
        return;
      }
      checkCount++;
    } catch (err) {
      // Silent error handling
      checkCount++;
    }
  }, 100);

  return interval;
}

// Function to move payment terms element
function movePaymentTerms() {
  pollWithTimeout(function () {
    var term = document.querySelector("shopify-payment-terms");
    var title = document.querySelector("#shopstr-booking-box-title");
    if (!term || !title) {
      return false;
    }
    console.log("title & term found!")
    title.after(term);
    setupClickListener();

    return true; // Success, stop polling
  });
}

// Function to check for and remove button
function removeButton(contentDiv) {
  pollWithTimeout(function () {
    var buttonContainer = contentDiv.querySelector(
      '[data-testid="sample-plans-modal-continue-to-checkout-button"]',
    );

    if (buttonContainer) {
      var button = buttonContainer.querySelector("button");
      if (button) {
        button.remove();
        return true; // Success, stop polling
      }
    }

    return false; // Continue polling
  });
}

// Function to check for portal and handle button removal
function checkForPortal() {
  pollWithTimeout(function () {
    var portal = document.querySelector(
      '[data-nametag="shop-portal-provider"][data-type="modal"]',
    );

    if (portal && portal.shadowRoot) {
      var contentDiv = portal.shadowRoot.querySelector(
        '[data-testid="sample-plans-modal-content"]',
      );

      if (contentDiv) {
        // Portal found, stop polling and remove button
        removeButton(contentDiv);
        return true; // Success, stop polling
      }
    }

    return false; // Continue polling
  });
}

// Function to set up click event listener
function setupClickListener() {
  pollWithTimeout(function () {
    var paymentTerms = document.querySelector(
      "#booking-box > shopify-payment-terms",
    );
    if (!paymentTerms || !paymentTerms.shadowRoot) {
      return false;
    }

    var ctaButton = paymentTerms.shadowRoot.querySelector(
      "#shopify-installments-cta",
    );
    if (!ctaButton) {
      return false;
    }

    // Found the button, set up click listener
    ctaButton.addEventListener("click", function () {
      checkForPortal();
    });
    return true; // Success, stop polling
  });
}

movePaymentTerms();
